import scIcon from '../../images/sc.svg'
const SCIcon: React.FC<any> = () => {
    return <span
    style={{display: 'inline-flex',
     alignItems: 'center',
     border: '1px solid #e71316',
     borderRadius: '12px',
     color: '#e71316',
     padding: '1px 6px',
     }}
    ><img src={scIcon}></img><span style={{paddingLeft: '4px', fontSize: '10px', whiteSpace: 'nowrap'}}>现货中心</span></span>
}

export default SCIcon;